import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
    import ('@/containers/DefaultContainer')

// Views
const Dashboard = () =>
    import ('@/views/Dashboard')

const Colors = () =>
    import ('@/views/theme/Colors')
const Typography = () =>
    import ('@/views/theme/Typography')

const Charts = () =>
    import ('@/views/Charts')
const Widgets = () =>
    import ('@/views/Widgets')
const Reports = () =>
    import ('@/views/reportgeneration')

// Views - Components
const Cards = () =>
    import ('@/views/base/Cards')
const Forms = () =>
    import ('@/views/base/Forms')
const Switches = () =>
    import ('@/views/base/Switches')
const Tables = () =>
    import ('@/views/base/Tables')
const Tabs = () =>
    import ('@/views/base/Tabs')
const Breadcrumbs = () =>
    import ('@/views/base/Breadcrumbs')
const Carousels = () =>
    import ('@/views/base/Carousels')
const Collapses = () =>
    import ('@/views/base/Collapses')
const Jumbotrons = () =>
    import ('@/views/base/Jumbotrons')
const ListGroups = () =>
    import ('@/views/base/ListGroups')
const Navs = () =>
    import ('@/views/base/Navs')
const Navbars = () =>
    import ('@/views/base/Navbars')
const Paginations = () =>
    import ('@/views/base/Paginations')
const Popovers = () =>
    import ('@/views/base/Popovers')
const ProgressBars = () =>
    import ('@/views/base/ProgressBars')
const Tooltips = () =>
    import ('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () =>
    import ('@/views/buttons/StandardButtons')
const ButtonGroups = () =>
    import ('@/views/buttons/ButtonGroups')
const Dropdowns = () =>
    import ('@/views/buttons/Dropdowns')
const BrandButtons = () =>
    import ('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () =>
    import ('@/views/icons/Flags')
const FontAwesome = () =>
    import ('@/views/icons/FontAwesome')
const SimpleLineIcons = () =>
    import ('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () =>
    import ('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () =>
    import ('@/views/notifications/Alerts')
const Badges = () =>
    import ('@/views/notifications/Badges')
const Modals = () =>
    import ('@/views/notifications/Modals')

// Views - Pages
const Page404 = () =>
    import ('@/views/pages/Page404')
const Page500 = () =>
    import ('@/views/pages/Page500')
const Login = () =>
    import ('@/views/pages/Login')
const Register = () =>
    import ('@/views/pages/Register')

// Users
const Users = () =>
    import ('@/views/users/Users')
const User = () =>
    import ('@/views/users/User')
const addablog = () =>
    import ('@/views/users/addablog')
const blogList = () =>
    import ('@/views/users/blogList')
const editblog = () =>
    import ('@/views/users/editblog')
const addaturtle = () =>
    import ('@/views/users/addaturtle')
const listturtles = () =>
    import ('@/views/users/listturtles')
const listturtles1 = () =>
    import ('@/views/users/listturtles1')
const editaturtle = () =>
    import ('@/views/users/editaturtle')
const Subscribers = () =>
    import ('@/views/users/Subscribers')
const userlist = () =>
    import ('@/views/users/userlist')
const adminslist = () =>
    import ('@/views/users/adminslist')
const reportlist = () =>
    import ('@/views/users/reportlist')
const sightingsloc = () =>
    import ('@/views/users/sightingsloc')
const sightingslocdash = () =>
    import ('@/views/users/sightingslocdash')
const sightingsloc1 = () =>
    import ('@/views/users/sightingsloc1')
const rescuecntloc = () =>
    import ('@/views/users/rescuecntloc')
const rescue = () =>
    import ('@/views/users/rescue')
const observation = () =>
    import ('@/views/users/observation')
const addanadmin = () =>
    import ('@/views/users/addanadmin')
const editadmin = () =>
    import ('@/views/users/editadmin')
const addauser = () =>
    import ('@/views/users/addauser')
const edituser = () =>
    import ('@/views/users/edituser')
const myprofile = () =>
    import ('@/views/users/myprofile')
const editmyprofile = () =>
    import ('@/views/users/editmyprofile')
const addrescuecenter = () =>
    import ('@/views/users/addrescuecenter')
const rescueCentersList = () =>
    import ('@/views/users/rescueCentersList')
const editrescuecenter = () =>
    import ('@/views/users/editrescuecenter')
const rescuesingleloc = () =>
    import ('@/views/users/rescuesingleloc')
const sightingsview = () =>
    import ('@/views/users/sightingsview')
const editsightings = () =>
    import ('@/views/users/editsightings')
const fileupload = () =>
    import ('@/views/users/fileupload')




import store from '../store'

Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: DefaultContainer,
            meta: {
                requiresAuth: true
            },
            children: [{
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'theme',
                    redirect: '/theme/colors',
                    name: 'Theme',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'colors',
                            name: 'Colors',
                            component: Colors
                        },
                        {
                            path: 'typography',
                            name: 'Typography',
                            component: Typography
                        }
                    ]
                },
                {
                    path: 'reportgeneration',
                    name: 'Reports',
                    component: Reports
                },
                {
                    path: 'charts',
                    name: 'Charts',
                    component: Charts
                },
                {
                    path: 'widgets',
                    name: 'Widgets',
                    component: Widgets
                },
                {
                    path: 'users',
                    meta: { label: 'Users' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Users,
                        },
                        {
                            path: ':id',
                            meta: { label: 'User Details' },
                            name: 'User',
                            component: User,
                        },
                    ]
                },
                {
                    path: 'base',
                    redirect: '/base/cards',
                    name: 'Base',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'cards',
                            name: 'Cards',
                            component: Cards
                        },
                        {
                            path: 'forms',
                            name: 'Forms',
                            component: Forms
                        },
                        {
                            path: 'switches',
                            name: 'Switches',
                            component: Switches
                        },
                        {
                            path: 'tables',
                            name: 'Tables',
                            component: Tables
                        },
                        {
                            path: 'tabs',
                            name: 'Tabs',
                            component: Tabs
                        },
                        {
                            path: 'breadcrumbs',
                            name: 'Breadcrumbs',
                            component: Breadcrumbs
                        },
                        {
                            path: 'carousels',
                            name: 'Carousels',
                            component: Carousels
                        },
                        {
                            path: 'collapses',
                            name: 'Collapses',
                            component: Collapses
                        },
                        {
                            path: 'jumbotrons',
                            name: 'Jumbotrons',
                            component: Jumbotrons
                        },
                        {
                            path: 'list-groups',
                            name: 'List Groups',
                            component: ListGroups
                        },
                        {
                            path: 'navs',
                            name: 'Navs',
                            component: Navs
                        },
                        {
                            path: 'navbars',
                            name: 'Navbars',
                            component: Navbars
                        },
                        {
                            path: 'paginations',
                            name: 'Paginations',
                            component: Paginations
                        },
                        {
                            path: 'popovers',
                            name: 'Popovers',
                            component: Popovers
                        },
                        {
                            path: 'progress-bars',
                            name: 'Progress Bars',
                            component: ProgressBars
                        },
                        {
                            path: 'tooltips',
                            name: 'Tooltips',
                            component: Tooltips
                        }
                    ]
                },
                {
                    path: 'buttons',
                    redirect: '/buttons/standard-buttons',
                    name: 'Buttons',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'standard-buttons',
                            name: 'Standard Buttons',
                            component: StandardButtons
                        },
                        {
                            path: 'button-groups',
                            name: 'Button Groups',
                            component: ButtonGroups
                        },
                        {
                            path: 'dropdowns',
                            name: 'Dropdowns',
                            component: Dropdowns
                        },
                        {
                            path: 'brand-buttons',
                            name: 'Brand Buttons',
                            component: BrandButtons
                        }
                    ]
                },
                {
                    path: 'icons',
                    redirect: '/icons/font-awesome',
                    name: 'Icons',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'coreui-icons',
                            name: 'CoreUI Icons',
                            component: CoreUIIcons
                        },
                        {
                            path: 'flags',
                            name: 'Flags',
                            component: Flags
                        },
                        {
                            path: 'font-awesome',
                            name: 'Font Awesome',
                            component: FontAwesome
                        },
                        {
                            path: 'simple-line-icons',
                            name: 'Simple Line Icons',
                            component: SimpleLineIcons
                        }
                    ]
                },
                {
                    path: '/addablog',
                    name: 'addablog',
                    component: addablog,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/blogList',
                    name: 'blog list',
                    component: blogList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/editblog/:id',
                    name: 'editblog',
                    component: editblog,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/addaturtle',
                    name: 'addaturtle',
                    component: addaturtle,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/listturtles',
                    name: 'listturtles',
                    component: listturtles,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/listturtles1',
                    name: 'listturtles1',
                    component: listturtles1,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/editaturtle/:id',
                    name: 'editaturtle',
                    component: editaturtle,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/subscribers',
                    name: 'Subscribers',
                    component: Subscribers,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/addauser',
                    name: 'addauser',
                    component: addauser,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/userlist',
                    name: 'userlist',
                    component: userlist,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/edituser/:id',
                    name: 'edituser',
                    component: edituser,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/addanadmin',
                    name: 'AddAdmin',
                    component: addanadmin,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/adminslist',
                    name: 'adminslist',
                    component: adminslist,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/editadmin/:id',
                    name: 'editadmin',
                    component: editadmin,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/reportlist',
                    name: 'reportlist',
                    component: reportlist,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/sightingsview/:id',
                    name: 'sightingsview',
                    component: sightingsview,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/editsightings/:id',
                    name: 'sightings',
                    component: editsightings,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/observation',
                    name: 'observation',
                    component: observation,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/rescue',
                    name: 'rescue',
                    component: rescue
                },
                {
                    path: '/addrescuecenter',
                    name: 'addrescuecenter',
                    component: addrescuecenter
                },
                {
                    path: '/editrescuecenter/:id',
                    name: 'editrescuecenter',
                    component: editrescuecenter,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/rescuesingleloc/:id',
                    name: 'rescuesingleloc',
                    component: rescuesingleloc,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/rescueCentersList',
                    name: 'rescueCentersList',
                    component: rescueCentersList
                },
                {
                    path: '/sightingsloc',
                    name: 'sightingsloc',
                    component: sightingsloc,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/sightingslocdash',
                    name: 'sightingsdash',
                    component: sightingslocdash,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/sightingsloc1/:id',
                    name: 'sightingsLocation',
                    component: sightingsloc1,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/rescuecntloc',
                    name: 'rescuecntloc',
                    component: rescuecntloc,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/editmyprofile/:id',
                    name: 'editmyprofile',
                    component: editmyprofile,
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/myprofile',
                    name: 'MyProfile',
                    component: myprofile,
                    meta: {
                        requiresAuth: true,
                    },

                },
                {
                    path: '/fileupload',
                    name: 'fileupload',
                    component: fileupload,
                    meta: {
                        requiresAuth: true,
                    },
                },

                {
                    path: 'notifications',
                    redirect: '/notifications/alerts',
                    name: 'Notifications',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'alerts',
                            name: 'Alerts',
                            component: Alerts
                        },
                        {
                            path: 'badges',
                            name: 'Badges',
                            component: Badges
                        },
                        {
                            path: 'modals',
                            name: 'Modals',
                            component: Modals
                        }
                    ]
                }
            ],
        },

        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render(c) { return c('router-view') }
            },
            children: [{
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '/login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },

                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                }
            ]
        },

    ]
})

router.beforeEach((to, from, next) => {
    // check if the route requires authentication and user is not logged in
    if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
        var dat = {}
        dat['x-auth-token'] = localStorage.getItem('token')
        axios({
                method: 'POST',
                url: '/validate/token',
                data: dat
            }).then(response => {
                if (response.data.status === false) {
                    store.commit('logoutUser', true)
                    next({
                        path: '/login',
                    })
                }
            })
            .catch(e => {
                var err

                alert('No Network Found!! please do a refresh ')
                err.push(e)
                window.location.reload()
            })
    }
    if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
        // redirect to login page
        next({
            name: 'Login'
        })
        return
    }

    // if logged in redirect to dashboard
    if (to.path === '/login' && store.state.isLoggedIn) {
        console.log('abcd')
        next({
            path: '/login'
        })
        return
    }
    next()
})

export default router

// export default new Router({
//   mode: 'hash', // https://router.vuejs.org/api/#mode
//   linkActiveClass: 'open active',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: configRoutes()
// })